import TomSelect from "tom-select"

const tomSelectSelector = "select.tom-select, input.tom-select"

const tomSelectOptions = {
    create: false,
    maxOptions: null,
    sortField: { field: "text", direction: "asc" },
    plugins: [
        "remove_button",
        "dropdown_input"
    ],
    render: {
        option: function(data, escape) {
            return `<div>${escape(data.text)}</div>`
        }
    }
}

const restoreStaleTomSelect = (el) => {
    if (!el.classList.contains("tomselected") || el.tomselect) return

    const wrapper = el.nextElementSibling
    if (wrapper?.classList.contains("ts-wrapper")) {
        wrapper.remove()
    }

    el.classList.remove("tomselected", "ts-hidden-accessible")
    el.removeAttribute("tabindex")
}

const initTomSelect = (root = document) => {
    root.querySelectorAll(tomSelectSelector).forEach((el) => {
        if (el.tomselect) return

        restoreStaleTomSelect(el)
        new TomSelect(el, tomSelectOptions)
    })
}

const destroyTomSelect = () => {
    document.querySelectorAll(tomSelectSelector).forEach((el) => {
        if (!el.tomselect) return

        el.tomselect.destroy()
    })
}

document.addEventListener("DOMContentLoaded", () => initTomSelect())
document.addEventListener("turbo:load", () => initTomSelect())
document.addEventListener("turbo:frame-load", (event) => initTomSelect(event.target))
document.addEventListener("turbo:before-cache", () => {
    destroyTomSelect()
})
